import { useRef, useState } from "react";
import * as SwitchPrimitives from "@radix-ui/react-switch";
import { Pencil } from "lucide-react";

const HoverLabel = ({ text, show }) => (
  <span role="tooltip"
    className={`pointer-events-none absolute right-0 top-full mt-1.5 z-20 whitespace-nowrap rounded-md bg-foreground px-2 py-1 text-xs font-medium text-background shadow-md transition-opacity duration-150 ${show ? "opacity-100" : "opacity-0 group-hover:opacity-100"}`}>
    {text}
  </span>
);

const useTouchTip = () => {
  const [show, setShow] = useState(false);
  const t = useRef();
  const flash = () => { setShow(true); clearTimeout(t.current); t.current = setTimeout(() => setShow(false), 1600); };
  return [show, flash];
};

export const WorkshopCardActions = ({ workshop, onEdit, onToggle }) => {
  const [busy, setBusy] = useState(false);
  const [tipSwitch, flashSwitch] = useTouchTip();
  const [tipEdit, flashEdit] = useTouchTip();
  const on = !!workshop.active;
  const label = on ? "Activado" : "Desactivado";

  const toggle = async () => {
    setBusy(true);
    try { await onToggle(); } finally { setBusy(false); flashSwitch(); }
  };

  return (
    <div className="flex items-center gap-1.5 shrink-0" data-testid={`workshop-actions-${workshop.id}`}>
      <span className="relative group" onTouchStart={flashEdit}>
        <button type="button" onClick={onEdit} aria-label="Editar taller" data-testid={`edit-workshop-${workshop.id}`}
          className="grid place-items-center w-8 h-8 rounded-full text-muted-foreground hover:text-primary hover:bg-primary/10 transition-colors">
          <Pencil className="w-4 h-4" />
        </button>
        <HoverLabel text="Editar" show={tipEdit} />
      </span>
      <span className="relative group" onTouchStart={flashSwitch}>
        <SwitchPrimitives.Root checked={on} onCheckedChange={toggle} disabled={busy} aria-label={label}
          data-testid={`toggle-workshop-${workshop.id}`} data-state-label={label}
          className="inline-flex h-6 w-11 shrink-0 cursor-pointer items-center rounded-full border border-border bg-muted p-0.5 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring disabled:opacity-60 disabled:cursor-wait">
          <SwitchPrimitives.Thumb
            className={`block h-[18px] w-[18px] rounded-full shadow ring-2 ring-background transition-[transform,background-color] duration-200 data-[state=checked]:translate-x-5 data-[state=unchecked]:translate-x-0 ${on ? "bg-emerald-500" : "bg-red-500"}`} />
        </SwitchPrimitives.Root>
        <HoverLabel text={label} show={tipSwitch} />
      </span>
    </div>
  );
};
